var map = {
	"./dragIcon.gif": 1403,
	"./dragIconBlack.gif": 1404,
	"./dragIconH.gif": 1405,
	"./dragIconHBlack.gif": 1406,
	"./dragIconRectBig.png": 1407,
	"./dragIconRectBig.svg": 1408,
	"./dragIconRectBigBlack.png": 1409,
	"./dragIconRectBigBlack.svg": 1410,
	"./dragIconRectBigBlackH.png": 1411,
	"./dragIconRectBigBlackH.svg": 1412,
	"./dragIconRectBigH.png": 1413,
	"./dragIconRectBigH.svg": 1414,
	"./dragIconRectSmall.png": 1415,
	"./dragIconRectSmall.svg": 1416,
	"./dragIconRectSmallBlack.png": 1417,
	"./dragIconRectSmallBlack.svg": 1418,
	"./dragIconRectSmallBlackH.png": 1419,
	"./dragIconRectSmallBlackH.svg": 1420,
	"./dragIconRectSmallH.png": 1421,
	"./dragIconRectSmallH.svg": 1422,
	"./dragIconRoundBig.png": 1423,
	"./dragIconRoundBig.svg": 1424,
	"./dragIconRoundBigBlack.png": 1425,
	"./dragIconRoundBigBlack.svg": 1426,
	"./dragIconRoundBigBlackH.png": 1427,
	"./dragIconRoundBigBlackH.svg": 1428,
	"./dragIconRoundBigH.png": 1429,
	"./dragIconRoundBigH.svg": 1430,
	"./dragIconRoundSmall.png": 1431,
	"./dragIconRoundSmall.svg": 1432,
	"./dragIconRoundSmallBlack.png": 1433,
	"./dragIconRoundSmallBlack.svg": 1434,
	"./dragIconRoundSmallBlackH.png": 1435,
	"./dragIconRoundSmallBlackH.svg": 1436,
	"./dragIconRoundSmallH.png": 1437,
	"./dragIconRoundSmallH.svg": 1438,
	"./eraserIcon.svg": 1439,
	"./eraserIconH.svg": 1440,
	"./export.png": 1441,
	"./exportWhite.png": 1442,
	"./lens.png": 1443,
	"./lens.svg": 1444,
	"./lensWhite.png": 1445,
	"./lensWhite.svg": 1446,
	"./lensWhite_old.png": 1447,
	"./lens_old.png": 1448,
	"./pencilIcon.svg": 1449,
	"./pencilIconH.svg": 1450,
	"./xIcon.svg": 1451,
	"./xIconH.svg": 1452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 814;